









































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* component */
import MapMarker from '@/app/components/Field/MapMarker.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'

@Component({
  components: {
    MapMarker,
    ConfirmModal
  }
})
export default class Map extends Vue {
  private basicData: {[key:string]: string|any} = this.$store.state.mapState.basicData
  private mapOption: {[key:string]: string|boolean} = {}
  private showConfirmModal: boolean = false
  private confirmMessage: string = '<p>アグリノート・FW2を同時に開くとメモリを消費して<br>端末の動作が不安定になることがありますが、開きますか？</p>'
  @Prop() private mapData!: Array<{[key:string]: string|number|any}>

  private get getMapData () {
    return this.mapData
  }
  @Watch('getMapData')
  // mapDataが1件以上あればzoomを18にする
  propMapData (newData:any) {
    if (newData.length !== 0) {
      this.basicData.zoom = 18
    }
  }

  /* computed */
  private get fieldChoiceState (): string {
    return this.$store.state.fieldChoiceState.id
  }
  /* computed */
  private get modalFieldChoiceState (): string {
    return this.$store.state.fieldChoiceState.modalId
  }

  @Watch('fieldChoiceState')
  onIdChange (newValue: string) : void {
    let id = parseInt(newValue)

    for (var i in this.mapData) {
      if (this.mapData[i].path.length !== 0) {
        if (this.mapData[i].id === id) {
          this.basicData.position = this.mapData[i].path[0]
        }
      } else {
        if (this.mapData[i].id === id) {
          this.basicData.position = this.mapData[i].fieldPosition
        }
      }
    }
  }

  @Watch('modalFieldChoiceState')
  onModalIdChange (newValue: string) : void {
    let id = parseInt(newValue)

    for (var i in this.mapData) {
      if (this.mapData[i].path.length !== 0) {
        if (this.mapData[i].id === id) {
          this.basicData.position = this.mapData[i].path[0]
        }
      } else {
        if (this.mapData[i].id === id) {
          this.basicData.position = this.mapData[i].fieldPosition
        }
      }
    }
  }

  private get getListLeadPosition (): any {
    return this.$store.state.mapState.basicData.position
  }
  @Watch('getListLeadPosition')
  getPosition (val: any) : void {
    this.basicData.position = val
  }

  /* 同じ圃場を二回選択したときも強制的に中央にする */
  private get clickFlag (): boolean {
    return this.$store.state.fieldChoiceState.clickFlag
  }
  @Watch('clickFlag')
  getClickFlag (flag: boolean) : void {
    if (flag) {
      let id = this.$store.state.fieldChoiceState.id
      for (var i in this.mapData) {
        if (this.mapData[i].path.length !== 0) {
          if (this.mapData[i].id === id) {
            if (this.basicData.position === this.mapData[i].path[1]) {
              this.basicData.position = this.mapData[i].path[0]
            } else {
              this.basicData.position = this.mapData[i].path[1]
            }
          }
        } else {
          if (this.mapData[i].id === id) {
            this.basicData.position = this.mapData[i].fieldPosition
          }
        }
      }
      /* フラグリセット */
      this.$store.commit('fieldChoiceState/setClickFlag', false)
    }
  }

  /* 同じ圃場を二回選択したときも強制的に中央にする(モーダル) */
  private get clickModalFlag (): boolean {
    return this.$store.state.fieldChoiceState.clickModalFlag
  }
  @Watch('clickModalFlag')
  getClickModalFlag (flag: boolean) : void {
    if (flag) {
      let id = this.$store.state.fieldChoiceState.modalId
      for (var i in this.mapData) {
        if (this.mapData[i].path.length !== 0) {
          if (this.mapData[i].id === id) {
            if (this.basicData.position === this.mapData[i].path[1]) {
              this.basicData.position = this.mapData[i].path[0]
            } else {
              this.basicData.position = this.mapData[i].path[1]
            }
          }
        } else {
          if (this.mapData[i].id === id) {
            this.basicData.position = this.mapData[i].fieldPosition
          }
        }
      }
      /* フラグリセット */
      this.$store.commit('fieldChoiceState/setClickModalFlag', false)
    }
  }

  created () {
    if (this.$route.path === '/sp/field') {
      this.mapOption = { streetViewControl: false, mapTypeControl: false }
    } else {
      this.mapOption = {}
    }
  }

  private toAgri () {
    this.showConfirmModal = false
    window.open('https://agri-note.jp/b/login/mizu.html', '_blank')
  }
}
